module.exports = __webpack_public_path__ + "img/symbol_2.7b96ac3b.png";